export default __webpack_public_path__ + "static/fans-star-coins-illustration-light-ff167303028964966956c8041bb4f7ed.svg";